<template>
    <v-dialog v-model="show" persistent max-width="600px">
        <v-card>
            <v-card-title class="heading pb-1">
                {{ data.title }}
            </v-card-title>
            <v-card-text class="pt-0 pb-2" v-html="data.content"></v-card-text>
            <v-card-actions class="justify-center pb-5">
                <v-btn v-if="typeof data.callback === 'function'"
                       :color="confirmColor"
                       rounded
                       @click="confirm()"
                       :loading="data.loading"
                >
                    {{ data.buttons ? data.buttons.confirm : 'تایید' }}
                </v-btn>
                <v-btn :color="dismissColor" dark rounded @click="dismiss()">
                    {{ data.buttons ? data.buttons.dismiss : 'بستن' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    export default {
        name: 'confirmPopup',
        props: ['data'],
        data() {
            return {
                show: true,
            };
        },
        computed: {
            confirmColor(){
                if(this.data.buttons && ('confirmColor' in this.data.buttons))
                    return this.data.buttons.confirmColor;

                return 'primary';
            },
            dismissColor(){
                if(this.data.buttons && ('dismissColor' in this.data.buttons))
                    return this.data.buttons.dismissColor;

                return 'grey';
            },
        },
        methods: {
            confirm() {
                this.data.callback(true);
            },
            dismiss() {
                this.data.callback(false);
                this.$emit('close');
            },
        },
    };
</script>
<style>
    .v-card__actions > .v-btn.v-btn {
        padding: 0 15px;
    }
</style>